import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3cc955c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "item gap-y-15",
  id: `section-0`,
  "data-section": "0"
}
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 1,
  class: "label"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 2,
  class: "label"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 3,
  class: "label"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 4,
  class: "label"
}
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 5,
  class: "label"
}
const _hoisted_13 = { class: "" }

import { formLabelStyle } from '@/components/cmForm/globalOpt';
import { risk_type } from '../types';
import { computed, PropType } from 'vue';
import { RiskDetail } from '../service';
import { Level } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident';
import dayjs from 'dayjs';
import { useI18n } from 'vue-i18n';

interface BaseInfoData extends Partial<RiskDetail> {
  ransomwareCmp?: Record<number, number>;
  leakCmp?: Record<number, number>;
  totalRansomwareCount?: number;
  totalLeakCount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInfo',
  props: {
  data: {
    type: Object as PropType<BaseInfoData | {ransomwareCmp: any,leakCmp:any,totalRansomwareCount:number,totalLeakCount:number}>,
    default: () => ({
      virus_risk: { untreated_virus_count: 0, virus_types: [] },
      ransomware_risk: [],
      leak_risk: [],
      baseline_risk: { scan_item_count: 0, violation_item_count: 0 },
      port_risk: { open_port_count: 0, risk_port_count: 0, unknown_port_count: 0 },
      weak_password_risk: { account_count: 0, weak_password_account_count: 0 },
      ransomwareCmp: {},leakCmp:{},totalRansomwareCount:0,totalLeakCount:0
    })
  }
},
  setup(__props) {

const { t, locale } = useI18n();
const details_tabs_label = computed<Record<number, string>>(() => {
  void locale.value
  return ({
  [risk_type.All]: t('responseHandle.detailTabRiskOverview'),
  [risk_type.virus]: t('responseHandle.detailTabVirusRisk'),
  [risk_type.vulnerability]: t('responseHandle.detailTabRansomwareRisk'),
  [risk_type.port]: t('responseHandle.detailTabPortInfo'),
  [risk_type.baseline]: t('responseHandle.detailTabLeakInfo'),
  [risk_type.blackmail]: t('responseHandle.detailTabBaselineInfo'),
  [risk_type.weak_mouth]: t('responseHandle.detailTabAccountInfo'),
  [risk_type.separated]: t('responseHandle.detailTabProcessInfo'),
})
});

const riskTypeLabelI18n = computed<Record<number, string>>(() => ({
  1: t('safeProtectionModule.riskCatWebSettings'),
  2: t('safeProtectionModule.riskCatSystemGeneral'),
  3: t('safeProtectionModule.riskCatSystemSecurity'),
  4: t('safeProtectionModule.riskCatBrowser'),
  5: t('safeProtectionModule.riskCatMobile'),
  6: t('safeProtectionModule.riskCatExtDir'),
  10000: t('safeProtectionModule.riskCatCustomDir'),
  20000: t('safeProtectionModule.fileSecurity'),
  1000000: t('safeProtectionModule.activeDefense'),
}))

const props = __props

// 如果外部没有传入计算属性，则内部计算
const ransomwareCmp = computed<Record<number, number>>(() => {
  if (props.data.ransomwareCmp) {
    return props.data.ransomwareCmp as Record<number, number>
  }
  return (props.data.ransomware_risk || []).reduce((p, c) => (p[c.level] = (c.ransomware_count || 0), p), {} as Record<number, number>)
})

const leakCmp = computed<Record<number, number>>(() => {
  if (props.data.leakCmp) {
    return props.data.leakCmp as Record<number, number>
  }
  return (props.data.leak_risk || []).reduce((p, c) => {
    if (c.warn_level === 0) {
      // 可选
      p[0] = (p[0] || 0) + (c.leak_count || 0)
    } else {
      // 高危（所有非0的都算高危）
      p[1] = (p[1] || 0) + (c.leak_count || 0)
    }
    return p
  }, {} as Record<number, number>)
})

const totalRansomwareCount = computed<number>(() => {
  if (props.data.totalRansomwareCount !== undefined) {
    return Number(props.data.totalRansomwareCount)
  }
  return Object.values(ransomwareCmp.value).reduce((p: number, c: number) => (p = p + Number(c), p), 0)
})

const totalLeakCount = computed<number>(() => {
  if (props.data.totalLeakCount !== undefined) {
    return Number(props.data.totalLeakCount)
  }
  return Object.values(leakCmp.value).reduce((p: number, c: number) => (p = p + Number(c), p), 0)
})

// 使用传入的 data
const data = computed(() => props.data)

const virusRiskTypeText = computed(() => {
  return (data.value.virus_risk?.virus_types || [])
    .map(item => riskTypeLabelI18n.value[item] || t(`responseHandle.riskItem${item}`))
    .join('、')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.asOfDate')) + " " + _toDisplayString(_unref(dayjs)().format('YYYY-MM-DD')) + "，", 1),
      _createElementVNode("span", null, _toDisplayString((data.value.virus_risk?.untreated_virus_count || 0) + (data.value.baseline_risk?.violation_item_count || 0) + (data.value.baseline_risk?.scan_item_count || 0) + totalRansomwareCount.value +
        totalLeakCount.value + (data.value.port_risk?.open_port_count || 0) === 0 ? _ctx.$t('responseHandle.riskSummaryNoRisk') : _ctx.$t('responseHandle.riskSummaryHasRisk')), 1)
    ]),
    (data.value.virus_risk?.untreated_virus_count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[1]), 5),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.virusRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.virus_risk.untreated_virus_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.virusRiskTypesExample')) + _toDisplayString(virusRiskTypeText.value) + _toDisplayString(_ctx.$t('responseHandle.virusRiskTypesSuffix')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString((data.value.virus_risk.virus_types || []).length), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.virusRiskTypesKind')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (totalRansomwareCount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[2]), 5),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.ransomwareRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(totalRansomwareCount.value), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.ransomwareRiskCases')), 1),
            (ransomwareCmp.value[_unref(Level).Heigh] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.highRiskEvents')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(ransomwareCmp.value[_unref(Level).Heigh] || 0), 1),
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.riskEventCasesComma')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (ransomwareCmp.value[_unref(Level).Middle] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.midRiskEvents')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(ransomwareCmp.value[_unref(Level).Middle] || 0), 1),
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.riskEventCasesComma')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (ransomwareCmp.value[_unref(Level).Low] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.lowRiskEvents')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(ransomwareCmp.value[_unref(Level).Low] || 0), 1),
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.riskEventCasesSemicolon')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (ransomwareCmp.value[_unref(Level).Default] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.unknownLevelEvents')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(ransomwareCmp.value[_unref(Level).Default] || 0), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.unknownLevelEventsSuffix')), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.ransomwareRiskTail')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (totalLeakCount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[4]), 5),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.leakRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(totalLeakCount.value), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.leakRiskHigh')), 1),
            (leakCmp.value[1] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(leakCmp.value[1]||0), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.leakRiskHighTail')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (leakCmp.value[0] || 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.leakRiskOptional')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(leakCmp.value[0] || 0), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.leakRiskOptionalTail')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (data.value.baseline_risk?.violation_item_count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[5]), 5),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.baselineRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.baseline_risk.scan_item_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.baselineRiskScan')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.baseline_risk.violation_item_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.baselineRiskViolation')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (data.value.port_risk?.open_port_count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[3]), 5),
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.portRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.port_risk.open_port_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.portRiskTotalTail')), 1),
            (data.value.port_risk.risk_port_count)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.portRiskIdentified')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(data.value.port_risk.risk_port_count), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.portRiskIdentifiedTail')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (data.value.port_risk.unknown_port_count)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.portRiskUnknown')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(data.value.port_risk.unknown_port_count), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.portRiskUnknownTail')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (data.value.weak_password_risk?.weak_password_account_count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(formLabelStyle))
          }, _toDisplayString(details_tabs_label.value[6]), 5),
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.weakPasswordRiskDesc')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.weak_password_risk.account_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.weakPasswordRiskAccounts')) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(data.value.weak_password_risk.weak_password_account_count), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.weakPasswordRiskFound')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})